import { useMemo } from 'react';
import { CountryCode } from '@dayetopia/types';
import { showInCountryCondition } from '@utils/country';
import { useCountry } from './useCountry';

/**
 * Custom hook to determine if content should be shown based on country conditions
 * Supports formats like:
 * - "US,GB" (show only in US and GB)
 * - "-US" (show in all countries except US)
 * - "US,-GB" (show in US and all countries except GB)
 *
 * @param {string} showInCountries - The show in countries configuration
 * @param {CountryCode} overrideCountry - The override country
 * @returns {boolean} Whether the content should be shown for the current country
 */
export const useShowInCountries = (showInCountries: string, overrideCountry?: CountryCode): boolean => {
  const { country: contextCountry } = useCountry();
  const country = overrideCountry || contextCountry;

  return useMemo(() => {
    return !showInCountries || showInCountryCondition(showInCountries, country);
  }, [showInCountries, country]);
};
